import type { Dispatch, SetStateAction } from "react";
import React from "react";
import cn from "classnames";
import { useTranslation } from "@litres-libs/i18n";
import { hasWindow } from "@litres/utils";
import { CatalogIconGray } from "../../../../static/icons/CatalogIconGray";
import { EPopups } from "../../../utils/enums";
import { trackerSendHeaderClick } from "../../../utils/analytics";
import styles from "./CatalogButton.module.scss";

export interface ICatalogButtonProps {
  setOpenedPopup: Dispatch<SetStateAction<EPopups>>;
  toggleGenres: () => void;
  genresButtonRef: React.RefObject<HTMLButtonElement>;
}

const CatalogButton = ({
  toggleGenres,
  setOpenedPopup,
  genresButtonRef,
}: ICatalogButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();

    setOpenedPopup(EPopups.Genres);
    toggleGenres();
    trackerSendHeaderClick(
      "Жанры (каталог)",
      hasWindow ? window.location.href : ""
    );
  };

  return (
    <button
      className={cn(styles.wrapper)}
      onClick={handleClick}
      ref={genresButtonRef}
      type="button"
      data-testid="header-catalog-button"
    >
      <CatalogIconGray />
      {t("Каталог")}
    </button>
  );
};

export default CatalogButton;
